import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import { GuruEntity } from '../../../../model/guru-entity';
import { ConfigurationSection, UserStateService } from '../../../../services/user-state.service';
import { ModelService } from '../../../../services/model-service';
import { SelectionUtils } from '../../../selection-utils';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-sp-res-accessories',
  imports: [MatIcon],
  templateUrl: './sp-res-accessories.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './sp-res-accessories.component.css',
})
export class SpResAccessoriesComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);
  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  serviceToolSelection!: GuruEntity;
  wallPlateSelection!: GuruEntity;
  outdoorTempSensorSelection!: GuruEntity;
  compressorSoftStartKitSelection!: GuruEntity;
  extendedWarrantySelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.ACCESSORIES;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.serviceToolSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USServiceTool');
    this.wallPlateSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USWallPlate');
    this.outdoorTempSensorSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USTempSensor');
    this.compressorSoftStartKitSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSoftStartKit');
    this.extendedWarrantySelection = SelectionUtils.getEntity(this.selectionEntities(), 'USWarranty');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }
}
